import { atom } from 'jotai';

// Atom to control the PhotoTipsDialog open state
export const improveResultsDialogOpenAtom = atom<{
  open: boolean;
  modelId?: string;
}>({
  open: false,
  modelId: undefined
});

// Unique identifier for this dialog in userDismissedItem
export const IMPROVE_RESULTS_DIALOG_ID = 'improve-results-dialog';
